import { createSlice } from '@reduxjs/toolkit';
import { localeSelector, type LanguageCode } from '@utils/LocaleSelector';
import { type RootState } from '.';

const htmlEl = document.querySelector('html');
const locale = localeSelector((htmlEl?.getAttribute('lang') as LanguageCode) || 'ko');
export interface IState {
    value: number;
    isNowbtnClicked: boolean;
    locale: string;
}

const initialState: IState = {
    value: 0,
    isNowbtnClicked: false,
    locale,
};

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        clickSaveBtn: (state) => {
            state.value += 1;
        },
        setIsNowbtnClicked: (state, action) => {
            state.isNowbtnClicked = action.payload;
        },
        setLocale: (state, action) => {
            state.locale = action.payload;
        },
    },
});

export const { clickSaveBtn, setIsNowbtnClicked, setLocale } = commonSlice.actions;

export const selectEventCount = (state: RootState): number => state.common.value;
export const selectIsNowbtnClicked = (state: RootState): boolean => state.common.isNowbtnClicked;
export const selectLocale = (state: RootState): string => state.common.locale;
export default commonSlice.reducer;
